export const StoryStyles = Object.freeze({
  LITTLE_PRINCE: "principito",
  GOLDEN_LIGHT: "golden_light",
  COLLAGE: "collage",
  COMIC: "comic",
  COLORED_PENCILS: "pencils",
  TEXTURED: "textured",
  VECTOR_ART: "vector",
});

export const StoryStyleLabels = {
  [StoryStyles.LITTLE_PRINCE]: "El principito",
  [StoryStyles.GOLDEN_LIGHT]: "Luz dorada",
  [StoryStyles.COLLAGE]: "Collage",
  [StoryStyles.COMIC]: "Cómic",
  [StoryStyles.COLORED_PENCILS]: "Lápices de colores",
  [StoryStyles.TEXTURED]: "Digital texturizado",
  [StoryStyles.VECTOR_ART]: "Arte vectorial",
};

export const StoryStyleOptions = Object.entries(StoryStyleLabels);
